import { useFetch } from "../../hooks/useFetch";

export const FetchAgentList = async (query) => {
  try {
    const data = await useFetch(
      `${process.env.REACT_APP_API_URL}/users`,
      query
    );

    return data.data;
  } catch (err) {
    return null;
  }
};
